import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Dropdown from './Dropdown';
//import {byProperty} from '../lib/utils';
import styled from 'styled-components';

const StyledEditScatter = styled.div`
  width: calc(100% - 32px);
  max-width: 730px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(51, 51, 51, .15);
  height: 70%;
  min-height: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%);
  z-index: 8;
  padding: 0 0 20px 0;
  & > div {
    padding: 0 20px;
    > span {
      letter-spacing: 1px;
    }
    &:first-child {
      h2 {
        font-family:'Helvetica Neue LT W01_35 Thin';
        font-size: 2em;
        float: left;
      }
      span {
        font-size: .825em;
        color: #999;
        text-transform: uppercase;
      }
      button {
        position: absolute;
        right: 20px;
        top: 40px;
        display: block;
        font-size: .825em;
        color: #000;
        i {
          margin: 2px 0 0 1em;
          width: 10px;
          height: 10px;
          float: right;
          svg {
            stroke: #000;
            stroke-width: 2;
          }
        }
        span {
          line-height: 15px;
          letter-spacing: 1px;
          display: none;
          @media (min-width: 640px) {
            display: inline-block;
          }
        }
      }
    }
    &:last-child {
      background: linear-gradient(to bottom,rgba(255, 255, 255, 0),#fff 20%);
      position: absolute;
      width: 100%;
      bottom: 0;
      button {
        width: 220px;
        height: 40px;
        justify-content: center;
        margin: 2.5em auto 1.5em auto;
      }
    }
  }
  .attributes {
    text-align: left;
    position: relative;
    padding: 0 0 40px 0;
    width: 100%;
    left: 0;
    height: calc(100% - 100px);
    overflow: auto;
    top: 0;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: #EEE;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #21A0D2;
      border: 2px solid #EEE;
    }
    > div {
      padding: 0 20px;
      > span {
        font-size: 0.625em;
        color: #999;
        text-transform: uppercase;
        letter-spacing: 0.5pt;
      }
      > em {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-style: normal;
        font-size: 0.75em;
        font-weight: bold;
        /* color: ${props => props.theme.red}; */
        text-transform: uppercase;
        letter-spacing: 0.5pt;
      }
    }

  }
`;

export default function EditScatter (props) {

  const {properties, chartProps, setChartProps, toggleLayer, visible} = props;
  const [currPorps, setCurrProps] = useState([]);
  const [alert, setAlert] = useState();

  const apply = () => {
    setChartProps(currPorps);
    toggleLayer("scatter");
  }

  useEffect(() => {
    if(!currPorps.length){
      setCurrProps(chartProps);
    }
  }, [properties, setCurrProps, currPorps, chartProps]);

  const data = properties.filter(item => item.type !== "sensory" && currPorps.indexOf(item.label) === -1).map(item => item.label);

  return (
    <StyledEditScatter visible={visible} >
      <div>
        <h2>Matrix</h2>
        <Button icon="close" label="close" transparent onClick={toggleLayer}/>
      </div>
      <div className="attributes">
      {alert ?
        <div>
          <em>The chart needs at least 1 attribute for each axis.</em>
        </div>
        :
        <div>
          <span>Edit x-axis</span>
          <Dropdown
            data={data}
            selected={currPorps[0]}
            onChange={(val) => setCurrProps([val, currPorps[1]])}
          />
          <span>Edit y-axis</span>
          <Dropdown
            data={data}
            selected={currPorps[1]}
            onChange={(val) => setCurrProps([currPorps[0], val])}
          />
        </div>
      }
      </div>
      <div>
      {alert ?
        <Button label="Ok" rounded blueBright onClick={() => setAlert(false)}/>
        :
        <Button label="Apply" rounded blueBright onClick={apply}/>
      }
      </div>
    </StyledEditScatter>)
}

EditScatter.propTypes = {
  color: PropTypes.string,
  open: PropTypes.bool,
  onToggle: PropTypes.func
};
